// Ventas en persona (fase 3). Contrato: docs/CONTRATO-API-FASE3.md.
//
// `mode` = 'empresa' (dueño, token `empresa-token`) o 'staff' (operador, token
// `staff-token`). Las rutas son las mismas; el backend decide por el token qué
// ve cada uno (el operador solo sus ventas y sus actividades asignadas).
import { empresaFetch } from './empresaApi';
import { ApiError, NETWORK_ERROR_MESSAGE, staffFetch } from './staffApi';

const fetcherFor = (mode) => (mode === 'staff' ? staffFetch : empresaFetch);

const query = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') search.set(key, String(value));
  });
  const text = search.toString();
  return text ? `?${text}` : '';
};

export const PAYMENT_METHODS = {
  cash: 'Efectivo',
  card_terminal: 'Terminal (tarjeta)',
  transfer: 'Transferencia',
};

export const paymentMethodLabel = (method) => PAYMENT_METHODS[method] || method || '—';

// Actividades `active` en las que puede vender, con precio, horarios y si piden CURP.
export const listSellableActivities = (mode) => fetcherFor(mode)('/api/empresa/sales/activities');

// Promotores elegibles para atribuir una venta en persona (aprobados y con
// relación aceptada con la empresa). Dueño u operador; el scanner recibe 403.
export const listSalePromoters = (mode) => fetcherFor(mode)('/api/empresa/sales/promoters');

export const createSale = (mode, payload) =>
  fetcherFor(mode)('/api/empresa/sales', { method: 'POST', body: payload });

// params: { from, to, activityId, status, page, limit }
export const listSales = (mode, params) => fetcherFor(mode)(`/api/empresa/sales${query(params)}`);

export const getSale = (mode, id) => fetcherFor(mode)(`/api/empresa/sales/${encodeURIComponent(id)}`);

// Solo el dueño (el backend responde 403 a un operador).
export const voidSale = (id, reason) =>
  empresaFetch(`/api/empresa/sales/${encodeURIComponent(id)}/void`, {
    method: 'POST',
    body: reason ? { reason } : {},
  });

// params: { date, activityId }
export const getEntries = (mode, params) => fetcherFor(mode)(`/api/empresa/entries${query(params)}`);

// Endpoint público (ya existía). Solo informativo: la venta vuelve a comprobar.
export const checkAvailability = async (activityId, date, time, quantity) => {
  let response;
  try {
    response = await fetch(
      `/api/activities/${encodeURIComponent(activityId)}/availability${query({ date, time, quantity })}`
    );
  } catch (e) {
    return null;
  }
  try {
    return await response.json();
  } catch (e) {
    return null;
  }
};

// Exportación (solo dueño): se baja con fetch + blob porque lleva el Bearer.
// params: { format, from, to, source, activityId, includeCurp }
export const downloadSalesExport = async (params) => {
  let response;
  try {
    response = await fetch(`/api/empresa/sales/export${query(params)}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('empresa-token')}` },
    });
  } catch (e) {
    throw new ApiError(NETWORK_ERROR_MESSAGE);
  }

  if (!response.ok) {
    let data = null;
    try {
      data = await response.json();
    } catch (e) {
      data = null;
    }
    throw new ApiError(
      (data && data.error) ||
        (response.status === 401
          ? 'Tu sesión de empresa venció. Inicia sesión de nuevo.'
          : 'No se pudo generar el archivo. Inténtalo de nuevo.'),
      { status: response.status, code: data && data.code, data }
    );
  }

  const disposition = response.headers.get('Content-Disposition') || '';
  const match = /filename="?([^";]+)"?/i.exec(disposition);
  const filename = match ? match[1] : `ventas.${params.format === 'xlsx' ? 'xlsx' : 'csv'}`;
  return { blob: await response.blob(), filename };
};

export const saveBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
